import React, { useState } from "react";
import logo from "../images/logo1.png";
import rmc from "../images/rmc.png";
import founder from "../images/founder.jpeg";
import director from "../images/director1.jpeg";
import director1 from "../images/director2.jpeg";
const AdiShivShaktiWebsite = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div className="font-sans text-gray-800 scroll-smooth">
      {/* Navbar */}
      <nav className="fixed top-0 left-0 w-full bg-white shadow z-50">
        <div className="max-w-6xl mx-auto px-6 py-4 flex justify-between items-center">
          <h1 className="text-xl font-bold text-purple-800">
            Adi-ShivShakti Buildtech Pvt Ltd
          </h1>

          {/* Desktop Menu */}
          <ul className="hidden lg:flex space-x-6 font-medium">
            <NavLink to="home" />
            <NavLink to="about" />
            <NavLink to="services" />
            <NavLink to="whyus" label="Why Us" />
            <NavLink to="rmc" label="RMC Plant" />
            <NavLink to="projects" />
            <NavLink to="leadership" />
            <NavLink to="contact" />
          </ul>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden text-2xl text-purple-800"
            onClick={() => setMenuOpen(!menuOpen)}
          >
            ☰
          </button>
        </div>

        {/* Mobile Menu */}
        {menuOpen && (
          <ul className="lg:hidden bg-white shadow-md px-6 py-4 space-y-4 font-medium">
            {[
              "home",
              "about",
              "services",
              "whyus",
              "rmc",
              "projects",
              "leadership",
              "contact",
            ].map((item) => (
              <li key={item}>
                <a
                  href={`#${item}`}
                  onClick={() => setMenuOpen(false)}
                  className="block"
                >
                  {item.toUpperCase()}
                </a>
              </li>
            ))}
          </ul>
        )}
      </nav>

      {/* Hero */}
      <section
        id="home"
        className="py-28 md:min-h-screen flex flex-col justify-center items-center bg-gradient-to-br from-stone-50 to-stone-200 text-white px-6 text-center"
      >
        <img src={logo} alt="Logo" className="w-90 h-80" />
        <h1 className="text-4xl md:text-5xl font-bold mb-4 text-gray-800">
          Building India with Strength & Precision
        </h1>
        <p className="max-w-3xl text-lg md:text-xl opacity-90 text-purple-800">
          Government contracting, infrastructure development, turnkey projects
          and in-house Ready Mix Concrete (RMC) solutions.
        </p>
      </section>

      {/* About */}
      <section id="about" className="py-16 px-6 max-w-6xl mx-auto">
        <SectionTitle title="About Us" />
        <p className="text-gray-700 text-lg leading-relaxed">
          Adi-ShivShakti Buildtech Pvt Ltd is a professionally managed
          construction company delivering civil, infrastructure, and government
          contracting projects with accuracy, compliance, and durability.
        </p>
        <p className="text-gray-700 text-lg mt-4">
          With an in-house <strong>Ready Mix Concrete (RMC) Plant</strong>, we
          ensure consistent quality, faster execution, and cost efficiency
          across all project types.
        </p>
      </section>

      {/* Services */}
      <section id="services" className="bg-gray-50 py-16 px-6">
        <div className="max-w-6xl mx-auto">
          <SectionTitle title="Our Services" />
          <div className="grid md:grid-cols-4 gap-6">
            <Service title="Government Contracts">
              Tender execution, BOQ compliance, quality control, and timely
              delivery.
            </Service>
            <Service title="Turnkey Projects">
              End-to-end execution from planning to handover.
            </Service>
            <Service title="Infrastructure Development">
              Roads, drainage, foundations & public works.
            </Service>
            <Service title="RMC Supply">
              High-strength concrete for all construction needs.
            </Service>
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section id="whyus" className="py-16 px-6 max-w-6xl mx-auto">
        <SectionTitle title="Why Choose Us" />
        <ul className="grid md:grid-cols-2 gap-4 text-lg text-gray-700">
          <li>✔ 21+ years of industry experience</li>
          <li>✔ In-house RMC plant advantage</li>
          <li>✔ Government contract expertise</li>
          <li>✔ Quality, safety & compliance focus</li>
          <li>✔ Skilled manpower & modern equipment</li>
          <li>✔ On-time & cost-effective delivery</li>
        </ul>
      </section>

      {/* RMC */}
      <section id="rmc" className="bg-gray-50 py-16 px-6">
        <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-10 items-center">
          <img
            src={rmc}
            alt="RMC Plant"
            className="rounded-2xl shadow-lg h-[320px] object-cover"
          />
          <div>
            <SectionTitle title="Ready Mix Concrete (RMC) Plant" />
            <p className="text-gray-700 text-lg">
              Our modern RMC plant ensures batch-controlled, IS-standard concrete
              for residential, commercial, and infrastructure projects.
            </p>
            <ul className="mt-4 space-y-2 text-gray-600">
              <li>✔ Grades: M20 to M40+</li>
              <li>✔ IS 4926 compliant</li>
              <li>✔ Timely dispatch & quality control</li>
              <li>✔ Cost-effective supply</li>
            </ul>
          </div>
        </div>
      </section>

      {/* Projects */}
      <section id="projects" className="py-16 px-6 max-w-6xl mx-auto">
        <SectionTitle title="Project Experience" />
        <div className="grid md:grid-cols-3 gap-6">
          <ProjectCard title="Government Civil Works" />
          <ProjectCard title="Roads & Drainage Projects" />
          <ProjectCard title="Residential & Commercial Buildings" />
        </div>
      </section>

      {/* Leadership */}
      <section id="leadership" className="bg-gray-50 py-16 px-6">
        <div className="max-w-6xl mx-auto">
          <SectionTitle title="Our Leadership" />
          <div className="grid md:grid-cols-3 gap-8">
            <Leader
              img={founder}
              name="Rajendra Namdev Mali"
              role="Founder & Managing Director"
              phone="9850373694"
            />
            <Leader
              img={director}
              name="Rohan Rajendra Mali"
              role="Director"
              phone="9168194393"
            />
            <Leader
              img={director1}
              name="Aniket Suresh Mali"
              role="Director"
              phone="9922573059"
            />
          </div>
        </div>
      </section>

      {/* Contact */}
      <section id="contact" className="py-16 px-6 max-w-6xl mx-auto">
        <SectionTitle title="Contact Us" />
        <p className="text-lg mb-4">
          Get in touch for project discussions, RMC supply, or partnerships.
        </p>
        <p><strong>Email:</strong> adishivshakti7171@gmail.com</p>
        <p><strong>Phone:</strong> +91 99225 73059</p>
        <p><strong>Address:</strong> At/Post: Upalavi Tal-Tasgaon Dist-Sangli, Maharashtra 416306</p>
      </section>

      {/* Footer */}
      <footer className="bg-purple-900 text-white text-center py-6">
        <p>© 2025 Adi-ShivShakti Buildtech Pvt Ltd</p>
        <p className="text-xs mt-1">GSTIN: 27ABDCA1926A1Z8</p>
      </footer>
    </div>
  );
};

/* ---------- Reusable Components ---------- */

const NavLink = ({ to, label }) => (
  <li>
    <a href={`#${to}`} className="hover:text-purple-700">
      {label || to.charAt(0).toUpperCase() + to.slice(1)}
    </a>
  </li>
);

const SectionTitle = ({ title }) => (
  <h2 className="text-3xl font-bold text-purple-800 mb-6">{title}</h2>
);

const Service = ({ title, children }) => (
  <div className="bg-white p-6 rounded-2xl shadow">
    <h3 className="text-xl font-semibold mb-3">{title}</h3>
    <p className="text-gray-600">{children}</p>
  </div>
);

const Leader = ({ img, name, role, phone }) => (
  <div className="bg-white p-6 rounded-2xl shadow text-center">
    <img src={img} alt={name} className="w-32 h-32 mx-auto mb-4 rounded-full object-fit" />
    <h3 className="text-xl font-semibold">{name}</h3>
    <p className="text-purple-700 font-medium">{role}</p>
    <p className="text-gray-600 mt-2 text-sm">📞 {phone}</p>
  </div>
);

const ProjectCard = ({ title }) => (
  <div className="bg-white p-6 rounded-2xl shadow text-center">
    <h3 className="text-lg font-semibold">{title}</h3>
  </div>
);

export default AdiShivShaktiWebsite;
